// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import Parser from "html-react-parser";
import { useContext, useEffect, useState } from "react";
import { Autoplay, Pagination } from "swiper/modules";
import { store } from "../../Helper/Context/Store";
import PostApiCall from "../../Helper/PostApi";
import ProductCard1 from "../ProductCard/ProductCard1";
import { Skeleton } from "antd";
export default function AllTimeFavouritesSection({ itemsData }) {
  const [items, setItems] = useState([])
  const { cartItems } = useContext(store)
  useEffect(() => {
    PostApiCall.postRequest(
      {
        stateid: 0,
        categoryid: parseInt(itemsData?.fld_categoryid)
      },
      "GetBestSellingProduct"
    ).then((results) =>
      results.json().then((obj1) => {
        if (results.status === 200 || results.status === 201) {
          setItems(obj1.data.filter((data) => data.fld_status === "Active"));
          // Notiflix.Loading.remove();
        }
      })
    )
    // eslint-disable-next-line
  }, [])

  return (
    <div className="section-spacing-x section-spacing-x-mobile">
      <div className="container-fluid pb-4" key="section-alltime-fav-1">
        <div className="row">
          <div className="col-lg-6 mx-auto text-center main-heading-box">

            <h2 className="main-heading">{itemsData.vertical_name}</h2>
            <p>
              {Parser(
                ("" + itemsData.fld_description + "")
                  .replace(/font-family/g, "")
                  .replace(/<br\/?>/gi, " ")
              )}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Swiper
              pagination={{
                dynamicBullets: true,
                clickable: true
              }}
              slidesPerView={2}
              spaceBetween={20}
              autoplay="false"
              // autoplay={{
              //   delay: 2500,
              //   disableOnInteraction: false,
              // }}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 10,
                },
              }}
              modules={[Autoplay, Pagination]}
              className="mySwiper pb-4 pb-lg-5 swiper-slide-height">
              {items.length > 0
                ? items.map((data, i) => {
                  const isInCart = cartItems.find((item) => item.fld_variantid === data.fld_variantid);
                  return (
                    <SwiperSlide key={`alltime-${data.fld_variantid}-${i}`}>
                      <ProductCard1 productData={data} isInCart={isInCart} />
                    </SwiperSlide>
                  );
                })
                : <div className="col-12">
                  <div className="row">
                    <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                    <div className={`col-md-6 col-lg-3 col-6 mb-4 mb-lg-0`}>
                      <div className="product-img-skeleton">
                        <Skeleton.Image className="h-100 w-100" />
                        <div className="buttons flex-column detailsbtn mb-0">
                          <h2 className="prod-price">
                            <Skeleton.Button />
                          </h2>
                        </div>
                        <div className="mt-3">
                          <Skeleton.Input />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
}
